import { asyncIterator as t } from "../ponyfill/asyncIterator.js";
ReadableStream.prototype.values ??= ReadableStream.prototype[Symbol.asyncIterator] ??= function(...e) {
  return t(this, ...e);
};
ReadableStream.prototype[Symbol.asyncIterator] ??= ReadableStream.prototype.values;
